<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>
<style lang="scss">
  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }


  }

.fa-circle-o-notch{
  color: #458afc;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.Hide{
  cursor: pointer;
  color: #A0A0A0;
}


.userImage{
  border: 1px solid #F0F0F0;
  border-radius: 5em;
  width: 4em;
  height: 4em;
  object-fit: cover;
  object-position: center right;
}

.AddForm{
  margin-top: 1em;
}

.fa-trash{
  color: red;
}

.fa-pencil{
  color: #458afc;
}

.seachButton{
  margin-top: 1.5em;
  width: 3em;
}

</style>
